/**
 * 尾程询价管理前端接口
 */

import { request } from '@/utils/http'
import { type BatchDeleteRequest, type PageResponse } from '@/api/types/common'
import {
  type ShokzInquiryBaseModel,
  type ShokzInquiryPageRequest,
  type ShokzInquirySaveRequest
} from './inquiry-base'

/**
 * 尾程询价模型（继承基础询价模型）
 */
export interface ShokzInquiryLastMileModel extends ShokzInquiryBaseModel {
  transportMode?: number | null
  originNodeType?: number | null
  originCountryId?: string | null
  originCityId?: string | null
  originSeaportId?: string | null
  originRailwayStationId?: string | null
  originAirportId?: string | null
  originTerminalId?: string | null
  originAirportTerminal?: string | null
  destinationCountryId?: string | null
  destinationCityId?: string | null
  destinationSeaportId?: string | null
  destinationRailwayStationId?: string | null
}

/**
 * 尾程询价分页查询请求参数
 */
export interface ShokzInquiryLastMilePageRequest extends ShokzInquiryPageRequest {}

/**
 * 尾程询价保存请求参数
 */
export interface ShokzInquiryLastMileSaveRequest extends ShokzInquirySaveRequest {
  transportMode?: number | null
  originNodeType?: number | null
  originCountryId?: string | null
  originCityId?: string | null
  originSeaportId?: string | null
  originRailwayStationId?: string | null
  originAirportId?: string | null
  originTerminalId?: string | null
  originAirportTerminal?: string | null
  destinationCountryId?: string | null
  destinationCityId?: string | null
  destinationSeaportId?: string | null
  destinationRailwayStationId?: string | null
}

export interface ShokzInquirySendEmailRequest {
  inquiryId: string | number
  supplierContactIds: Array<string | number>
}

/**
 * 分页查询尾程询价列表
 */
export const pageInquiryLastMile = (params: ShokzInquiryLastMilePageRequest) => {
  return request.post<PageResponse<ShokzInquiryLastMileModel>>(
    '/price/shokzInquiry/last-mile/page',
    params
  )
}

/**
 * 根据ID获取尾程询价详情
 */
export const getInquiryLastMileById = (id: string) => {
  // 提取纯数字ID部分，去除可能的额外信息
  const pureId = id.split(/\s+/)[0]
  return request.post<ShokzInquiryLastMileModel>('/price/shokzInquiry/last-mile/get', { id: pureId })
}

/**
 * 根据询价编号获取尾程询价详情
 */
export const getInquiryLastMileByInquiryNo = (inquiryNo: string) => {
  return request.post<ShokzInquiryLastMileModel>('/price/shokzInquiry/last-mile/get', { inquiryNo })
}

/**
 * 新增尾程询价
 */
export const saveInquiryLastMile = (params: ShokzInquiryLastMileSaveRequest) => {
  return request.post<boolean>('/price/shokzInquiry/last-mile/save', {
    ...params,
    strictRequiredValidation: true
  })
}

/**
 * 修改尾程询价
 */
export const updateInquiryLastMile = (params: ShokzInquiryLastMileSaveRequest) => {
  return request.post<boolean>('/price/shokzInquiry/last-mile/update', {
    ...params,
    strictRequiredValidation: true
  })
}

/**
 * 批量删除尾程询价
 */
export const batchDeleteInquiryLastMile = (params: BatchDeleteRequest) => {
  return request.post<boolean>('/price/shokzInquiry/last-mile/batch-delete', params)
}

export const sendInquiryEmail = (params: ShokzInquirySendEmailRequest) => {
  return request.post<boolean>('/price/shokzInquiry/last-mile/send-email', params)
}

// 类型别名（兼容老代码）
export type InquiryLastMileModel = ShokzInquiryLastMileModel
export type InquiryLastMilePageRequest = ShokzInquiryLastMilePageRequest
export type InquiryLastMileSaveRequest = ShokzInquiryLastMileSaveRequest
